import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const styles = {
  container: {
    padding: "10px",
    fontWeight: "100",
    lineHeight: "22px",
    backgroundColor: "#262626"
  },
  title: {
    fontWeight: "100"
  },
  
  Collapsible : {
	background: '#F50',
  },
};

export default styles;
